import { z } from 'zod';
import { TFunction } from 'i18next';

export const createPasswordSchema = (t: TFunction) =>
  z
    .object({
      oldPassword: z.string().min(1, t('validation.password.oldRequired', 'Old password is required')),
      newPassword: z
        .string()
        .min(8, t('validation.password.minLength', 'Password must be at least 8 characters'))
        .regex(
          /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,}$/,
          t(
            'validation.password.complexity',
            'Password must contain at least 8 characters, one lowercase, one uppercase, one number, and one special character'
          )
        ),
      retypePassword: z.string().min(1, t('validation.password.confirmRequired', 'Please confirm your password'))
    })
    .refine((data) => data.newPassword === data.retypePassword, {
      message: t('validation.password.mismatch', "Passwords don't match"),
      path: ['retypePassword']
    });

export type PasswordFormValues = z.infer<ReturnType<typeof createPasswordSchema>>;
